import { defHttp } from '@/hooks/use-requests';
import type { RequestOptions, UploadFileParams } from 'types/axios';

import { useGlobSetting } from '@/hooks/setting';
import type { VisitSceneEnum } from '@/types/common';

// 获取开通服务的城市
export const getCityList = (data: any) => {
  return defHttp.get({
    url: '/public/cities/',
    params: data,
  });
};

// 获取客服电话
export const getCustomerService = (data: any) => {
  return defHttp.get({
    url: '/common/get_customer_service/',
    params: data,
  });
};

// 行为计数上报
export const statCounting = (params: { scene_code: VisitSceneEnum }) => {
  return defHttp.post({
    url: '/public/stat_counting/',
    params,
  });
};

// 促销专用埋点统计，记录用户手机号
export const promoStatCounting = (params: { route: string, phone?: string }) => {
  return defHttp.post({
    url: '/public/alcohol/stat/',
    params,
  });
};

// 获取促销 bannerlink
export const getPromotionBannerLink = () => {
  return defHttp.get({
    url: '/public/config/get_by_name/',
    params: {
      name: "微醺",
    },
  });
};

// 用code获取微信openid（用户端）
export function getWxAuthInfo(params: any) {
  return defHttp.post({
    url: `/auth/wechat_login/`,
    params,
  });
}

// 用code获取微信openid（助教端）
export function getTeachWxAuthInfo(params: any, options?: RequestOptions) {
  return defHttp.post(
    {
      url: `/auth/cuebuddy_login/`,
      params,
    },
    options,
  );
}

// 助教注册/v1
export const registerCoach = (params: any, options?: RequestOptions) => {
  return defHttp.post(
    {
      url: '/auth/cuebuddy_register/',
      data: params,
    },
    options,
  );
};

// 修改助教信息
export const updateCoachInfo = (params: any) => {
  return defHttp.post({
    url: `/record/cuebuddy_records/`,
    params,
  });
};

// 获取台球馆列表
export function getBilliardVenues(data: any) {
  return defHttp.get({
    url: `/third/sites/`,
    params: data,
  });
}

const { uploadUrl = '' } = useGlobSetting();
// 上传文件
export function uploadApi(url = '', params: UploadFileParams) {
  return defHttp.uploadFile(
    {
      url: uploadUrl + url + '/upload/',
    },
    params,
  );
}
